export const rowsWrapperStyles = {
  minWidth: '320px',
  border: '1px solid',
  borderColor: ({ palette }) => palette.border.default,
  borderRadius: '8px',
};

export const rowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '24px',
  padding: '8px 24px',
  '&:not(:last-of-type)': {
    borderBottom: '1px solid',
    borderColor: ({ palette }) => palette.border.default,
  },
};

export const footerStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '24px',
  padding: '12px',
};
